// src/components/Teams/MemberList.js
import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';

const MemberList = ({ members, currentUserId, teamOwnerId, onRemove }) => {
    return (
        <Table responsive hover>
            <thead>
            <tr>
                <th>Uživatel</th>
                <th>Email</th>
                <th>Role</th>
                <th>Akce</th>
            </tr>
            </thead>
            <tbody>
            {members.map(member => (
                <tr key={member.id}>
                    <td>
                        <div className="d-flex align-items-center">
                            <div className="avatar-circle avatar-sm me-2">
                                {member.firstName && member.lastName ? (
                                    <span className="avatar-initials">
                      {member.firstName.charAt(0)}{member.lastName.charAt(0)}
                    </span>
                                ) : (
                                    <i className="fas fa-user"></i>
                                )}
                            </div>
                            <span>{member.firstName} {member.lastName}</span>
                        </div>
                    </td>
                    <td>{member.email}</td>
                    <td>
                        {member.id === teamOwnerId ? (
                            <Badge bg="primary">Vlastník</Badge>
                        ) : (
                            <Badge bg="secondary">Člen</Badge>
                        )}
                    </td>
                    <td>
                        {member.id !== currentUserId && member.id !== teamOwnerId && (
                            <Button
                                variant="outline-danger"
                                size="sm"
                                onClick={() => onRemove(member.id)}
                            >
                                <i className="fas fa-user-minus me-1"></i> Odebrat
                            </Button>
                        )}
                    </td>
                </tr>
            ))}
            </tbody>
        </Table>
    );
};

export default MemberList;